import React, { memo } from 'react';
import { Header3, BodyText } from 'library/components/text-elements';
import { Close } from 'library/icons';
import KeyCodes from 'library/helpers/key-codes';
import {
  StyledJourneySideModalHeading,
  StyledHeaderIcon,
  StyledExit,
  StyledLogoTitle,
} from './styled-journey-side-modal';

const JourneySideModalHeading = ({
  icon,
  header,
  description,
  toggleActive,
  descriptionStyle,
}) => {
  const handleKeyPressClose = (e) => {
    e.preventDefault();
    if (KeyCodes.POSITIVE_AFFIRMATIONS.includes(e.which)) {
      toggleActive();
    }
  };

  return (
    <StyledJourneySideModalHeading>
      <StyledHeaderIcon>
        <StyledLogoTitle>
          {icon}
          <Header3>{header}</Header3>
        </StyledLogoTitle>
        <StyledExit
          tabIndex={0}
          aria-label={'Close the modal'}
          onKeyUp={handleKeyPressClose}
        >
          <Close onClick={toggleActive} />
        </StyledExit>
      </StyledHeaderIcon>
      <BodyText tabIndex={0} style={descriptionStyle}>
        {description}
      </BodyText>
    </StyledJourneySideModalHeading>
  );
};

export default memo(JourneySideModalHeading);
